__turbopack_context__.v({
  "folderHeaderSharing": "FolderHeaderSharing-module__BG-Wqa__folderHeaderSharing",
});
